<template>
  <m-dialog ref="dlg" @save="save" :fullscreen="false" :isclose="false" :btnsave="false" :title="user && user.id ? 'Perbarui Data Pengguna' : 'Perbarui Data Pengguna'">
    <v-row row wrap justify="center" align="center">
      <v-card flat text class="ma-0 py-0">
        <v-card-text class="mb-0 pb-0">
          <v-form data-vv-scope="form" lazy-validation class="ma-5">
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" lg="12">
                <m-alert show title="Lengkapi Jenjang" info="Pilih <b>jenjang</b> dibawah ini untuk mengikuti kegiatan Diklat GTK"></m-alert>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="6">
                <v-select
                  outlined
                  dense
                  autocomplete="false"
                  v-model="user.jenjang"
                  :items="itemJenjangs"
                  item-text="keterangan"
                  item-value="id"
                  data-vv-name="jenjang"
                  data-vv-as="Jenjang"
                  hint="Jenjang"
                  return-object
                  v-validate="'required'"
                  label="Jenjang"
                  placeholder="Pilih Jenjang"
                  :error-messages="errors.collect('form.jenjang')"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      alert: ALERT_INFO,
      user: {},
      is_slb: false,

      itemJenjangs: []
    };
  },
  methods: {
    open(obj) {
      if (obj) {
        this.user = obj;
        this.is_slb = obj.jenjang && obj.jenjang.id == 6 ? true : false;
      }
      this.loadJenjang();

      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    // eslint-disable-next-line
    loadJenjang() {
      if (this.is_slb) {
        this.itemJenjangs = [
          {
            id: 102,
            keterangan: "SDLB"
          },
          {
            id: 103,
            keterangan: "SMPLB"
          },
          {
            id: 104,
            keterangan: "SMALB"
          }
        ];
      } else {
        this.itemJenjangs = [
          {
            id: 2,
            keterangan: "SD"
          },
          {
            id: 3,
            keterangan: "SMP"
          },
          {
            id: 4,
            keterangan: "SMA"
          },
          {
            id: 5,
            keterangan: "SMK"
          }
        ];
      }
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("user/create", {
            instansi_id: this.instansi_id,
            obj: this.user
          });
        })
        .then(res => {
          this.$info("Simpan Data Berhasil");
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    }
  }
};
</script>
